import { Tracker } from "./tracker";

export const defaultTrack = {
    id: '',
    trackerName: '',
    tracker: '',
    message: {},
    lat: 0,
    lon: 0,
    x: 0,
    y: 0,
    z: 0,
    createdDate: Date.now()
};

export interface Track {
    id: string;
    trackerName?: string;
    tracker: Tracker | string;
    message: Record<string, any>;
    lat: number;
    lon: number;
    x: number;
    y: number;
    z: number;
    createdDate: string | number;
}

export interface PostTrack {
    trackerName?: string;
    tracker: Tracker | string;
    message?: Record<string, any>;
    lat?: number;
    lon?: number;
    x?: number;
    y?: number;
    z?: number;
}

export interface PutTrack {
    id: string;
    trackerName?: string;
    tracker?: Tracker | string;
    message?: Record<string, any>;
    lat?: number;
    lon?: number;
    x?: number;
    y?: number;
    z?: number;
    createdDate?: string | number;
}